import React from "react";
import { Trans } from "react-i18next";
import Icon from "../../../utils/icon";
import "../assets/scss/admin-bar.scss";

const ListItem = ({ children, ...props }) => (
  <li className="admin-bar__menu-item" {...props}>
    {children}
  </li>
);

const AdminBar = ({
  session: { theme, administrationAccess, crmAccess, impersonating },
  opened,
  onClickButton,
  onMouseEnterButton,
  onMouseLeaveButton,
}) =>
  impersonating ? (
    <div className="admin-bar">
      <a
        href={Routing.generate("frontoffice_web_user_account", { _switch_user: "_exit" })}
        className="admin-bar__button admin-bar__button--impersonating"
      >
        <Icon icon="impersonation" size={24} className="visible-default" />
        <Icon icon="close" size={24} className="visible-hover" />
        <span className="hover-only">
          <Trans i18nKey={`${theme}:navbar.exit_impersonation`} />
        </span>
      </a>
    </div>
  ) : (
    <div
      className={`admin-bar ${opened === true ? "active" : ""}`}
      onMouseEnter={onMouseEnterButton}
      onMouseLeave={onMouseLeaveButton}
    >
      <button type="button" className="reset-button admin-bar__button" onClick={onClickButton}>
        <Icon icon="edit" size={24} className="edit-icon" />
      </button>
      <ul className="admin-bar__menu">
        {administrationAccess && window.isCountryInfoPage === true && (
          <React.Fragment>
            <ListItem>
              <a
                href="https://airtable.com/tbla2DwHyg4H1pI9q"
                target="_blank"
                rel="noopener noreferrer"
                style={{ backgroundColor: "#fff6db", color: "#786631" }}
              >
                Editer sur Airtable
              </a>
            </ListItem>
            <ListItem>
              <a href="?update-from-airtable" style={{ backgroundColor: "#e3ffdb", color: "#407831" }}>
                Mettre à jour depuis Airtable
              </a>
            </ListItem>
          </React.Fragment>
        )}
        {administrationAccess && (
          <ListItem>
            <a
              href={`${Routing.generate("backoffice_index")}${
                window.backofficeEditPage.path ? `/${window.backofficeEditPage.path}` : ""
              }`}
              style={{ backgroundColor: "#dbebff", color: "#315678" }}
            >
              <Trans i18nKey={`${theme}:navbar.backoffice`} /> {window.backofficeEditPage.name}
            </a>
          </ListItem>
        )}
        {crmAccess && (
          <ListItem bg="#ff867c">
            <a
              href={`${Routing.generate("crm_index")}${window.crmEditPage.path ? `/${window.crmEditPage.path}` : ""}`}
              style={{ backgroundColor: "#fadcdd", color: "#783131" }}
            >
              <Trans i18nKey={`${theme}:navbar.crm`} /> {window.crmEditPage.name}
            </a>
          </ListItem>
        )}
      </ul>
    </div>
  );
export default AdminBar;
